import {
  type CallStatusDetail,
  CallStatusDetailSchema,
  type CallStatusListQuery,
  type CallStatusListResponse,
  CallStatusListResponseSchema,
  type CreateCallStatusRequest,
  type UpdateCallStatusRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Call Status master API. Every response is validated with the shared Zod
 * schema so a server change can't sneak past the UI types.
 */

export const listCallStatuses = async (
  query: CallStatusListQuery,
): Promise<CallStatusListResponse> => {
  const { data } = await apiClient.get<unknown>('/call-statuses', { params: query });
  return CallStatusListResponseSchema.parse(data);
};

export const getCallStatus = async (id: string): Promise<CallStatusDetail> => {
  const { data } = await apiClient.get<unknown>(`/call-statuses/${id}`);
  return CallStatusDetailSchema.parse(data);
};

export const createCallStatus = async (
  payload: CreateCallStatusRequest,
): Promise<CallStatusDetail> => {
  const { data } = await apiClient.post<unknown>('/call-statuses', payload);
  return CallStatusDetailSchema.parse(data);
};

export const updateCallStatus = async (
  id: string,
  payload: UpdateCallStatusRequest,
): Promise<CallStatusDetail> => {
  const { data } = await apiClient.patch<unknown>(`/call-statuses/${id}`, payload);
  return CallStatusDetailSchema.parse(data);
};

export const deleteCallStatus = async (id: string): Promise<void> => {
  await apiClient.delete(`/call-statuses/${id}`);
};

export const bulkDeleteCallStatuses = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/call-statuses/bulk-delete', { ids });
  return data;
};

export const bulkSetCallStatusesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/call-statuses/bulk-set-status', { ids, isActive });
  return data;
};
